import "./external-libs/popper.min" // TODO: this can probably be replaced by importing the popper package
import $ from "jquery"
window.$ = $;
